/**
 * @generated SignedSource<<162ee00fd37e9fab42fad4e63f430d66>>
 * @relayHash 05bae897240e208934a7314720c18f00
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 39afc123c06c997743588fe8d7ca244af12fe910448210de00078d85d933617d

import type { ConcreteRequest } from 'relay-runtime';
export type PagesDisplayPersistenceOption = "CARDS" | "COMPACT_LIST" | "LIST" | "%future added value";
export type useHomeViewsUserPreferencesHomeViewsUserPreferencesMutation$variables = {
  appearance: PagesDisplayPersistenceOption;
};
export type useHomeViewsUserPreferencesHomeViewsUserPreferencesMutation$data = {
  readonly updateUserPreferences: {
    readonly homePagesDisplayView: PagesDisplayPersistenceOption;
  } | null;
};
export type useHomeViewsUserPreferencesHomeViewsUserPreferencesMutation = {
  response: useHomeViewsUserPreferencesHomeViewsUserPreferencesMutation$data;
  variables: useHomeViewsUserPreferencesHomeViewsUserPreferencesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appearance"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "homePagesDisplayView",
            "variableName": "appearance"
          }
        ],
        "kind": "ObjectValue",
        "name": "userPreferences"
      }
    ],
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "updateUserPreferences",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "homePagesDisplayView"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useHomeViewsUserPreferencesHomeViewsUserPreferencesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useHomeViewsUserPreferencesHomeViewsUserPreferencesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "05bae897240e208934a7314720c18f00",
    "id": "39afc123c06c997743588fe8d7ca244af12fe910448210de00078d85d933617d",
    "metadata": {},
    "name": "useHomeViewsUserPreferencesHomeViewsUserPreferencesMutation",
    "operationKind": "mutation",
    "text": "mutation useHomeViewsUserPreferencesHomeViewsUserPreferencesMutation($appearance:PagesDisplayPersistenceOption!){updateUserPreferences(userPreferences:{homePagesDisplayView:$appearance}){homePagesDisplayView}}"
  }
};
})();

(node as any).hash = "8413f3eedb4fdf231e9546613d4fa7b8";

export default node;
